<div class="modal-header" ngbAutofocus>
    <h3 class="modal-title">Unregister from Class</h3>
</div>
<div class="modal-body">
    Are you sure you want to unregister for <b>{{classInfo.ClassTitle}}</b>?
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="deleteClicked()">Unregister</button>
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">Cancel</button>
</div>